import { ROUTE_PATHS } from 'Constants/routing';
import { matchPath } from 'react-router';

/**
 * Returns current conversation id -- if in a conversation; otherwise empty string.
 * @param previewConversationId Optionally pass a previewConversationId from the store
 * @param pathname Optionally pass a pathname other than window.location.pathname
 */
export const getCurrentConversationId = (
  pathname?: string,
  previewConversationId?: string | null,
) => {
  const currentPath = pathname || window.location.pathname;

  if (matchPath(ROUTE_PATHS.newConversation.path, currentPath)) {
    return previewConversationId || '';
  }

  const conversationMatch = matchPath(
    ROUTE_PATHS.conversation.path,
    currentPath
  );

  if (conversationMatch?.params?.conversationId) {
    return conversationMatch.params.conversationId;
  }

  return '';
};
